import {
  useQuery,
  type UseQueryOptions,
  type QueryClient,
} from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import { getCustomerDietaryRestrictions } from '@hungryroot/rest/api/v2/customers/[id]/dietary_restrictions/get/get-customer-dietary-restrictions';

const timeLimit = 15 * 60 * 1000;
const queryKey = ['customer-dietary-restrictions'];

export function useCustomerDietaryRestrictions(
  options?: Pick<UseQueryOptions, 'enabled'>
) {
  return useQuery({
    queryKey,
    queryFn: async () => {
      const resp = await getCustomerDietaryRestrictions();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    retry: false,
    enabled: options?.enabled,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}

/**
 * Invalidates all queries related to customer dietary restrictions
 * @param queryClient The react-query client instance
 */
export function invalidateCustomerDietaryRestrictions(
  queryClient: QueryClient
) {
  queryClient.invalidateQueries({
    queryKey,
  });
}
